/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlannerSessionResponse
 */
export interface PlannerSessionResponse {
    /**
     * 
     * @type {string}
     * @memberof PlannerSessionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerSessionResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerSessionResponse
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof PlannerSessionResponse
     */
    updatedAt: string;
}

/**
 * Check if a given object implements the PlannerSessionResponse interface.
 */
export function instanceOfPlannerSessionResponse(value: object): value is PlannerSessionResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PlannerSessionResponseFromJSON(json: any): PlannerSessionResponse {
    return PlannerSessionResponseFromJSONTyped(json, false);
}

export function PlannerSessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerSessionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'createdAt': json['created_at'],
        'updatedAt': json['updated_at'],
    };
}

export function PlannerSessionResponseToJSON(json: any): PlannerSessionResponse {
    return PlannerSessionResponseToJSONTyped(json, false);
}

export function PlannerSessionResponseToJSONTyped(value?: PlannerSessionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

